<header
  [class]="(inSideNav || hasRoute('transactions') || hasRoute('parent-list')) ? 'sidenav' : 'bg-white border-bottom shadow-sm'">

  <!-- Estilos específicos para el sidenav -->
  <style *ngIf="inSideNav">
    /* Hacer que los ítems del menú ocupen el 100% del ancho en el sidenav */
    :host-context(.app-sidenav) a.nav-link {
      width: 100%;
      display: block;
    }

    :host-context(.app-sidenav) nav {
      width: 100%;
    }
  </style>

  <div class="sct-topbar wf-section" [hidden]="inSideNav">
    <a data-w-id="c23cc6fa-15e7-258c-af41-7341b9e255d6" (click)="isTopBarVisible = !isTopBarVisible"
      class="top-bar-top-div w-inline-block text-decoration-none">
      <img src="assets/images/favicon_32x32.png" loading="lazy" width="27" alt="" />
      <div class="top-bar-text-portal"><strong class="bold-text-2 ">Portal oficial del Gobierno de Puerto Rico.</strong>
      </div>
      <div class="top-bar-text"><strong class="bold-text text-white"></strong></div>
    </a>
    <div *ngIf="isTopBarVisible" class="top-bar-bottom-div">
      <div class="top-bar-bottom-content w-row">
        <div class="left-line-col w-col w-col-6 w-col-small-small-stack w-col-tiny-tiny-stack">
          <div class="top-bar-text">
            <strong>Un sitio web oficial .pr.gov</strong> pertenece a una organización oficial del Gobierno de Puerto
            Rico.
          </div>
        </div>
        <div class="left-line-col w-col w-col-6 w-col-small-small-stack w-col-tiny-tiny-stack">
          <div class="top-bar-text">
            <strong>Los sitios web seguros .pr.gov usan HTTPS,</strong> lo que significa que usted se conectó de forma
            segura a un sitio web.
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Vista para escritorio estándar - se oculta en medical-certificates -->
  <!-- <div>
    <div class="row col-12">
      <ng-container *ngIf="this.authService.isLoggedIn()">
        <div class="col-9 d-flex justify-content-start align-items-center">
          <div class="div-agency-category">
            <h1 class="agency-category">Salud Digital</h1>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!authService.isLoggedIn()">
        <div class="col-9 d-flex justify-content-start align-items-center">
          <div class="div-agency-category">
            <h1 class="agency-category">Salud Digital</h1>
          </div>
        </div>
      </ng-container>

      <div [class]="inSideNav ? 'col d-none' : 'col-3'">
        <img src="assets/images/Salud.png" alt="Salud Digital">
      </div>
    </div>
  </div> -->

  <!-- Vista para medical-certificates en desktop -->
  <div [hidden]="inSideNav" class="logo-text-container">
    <div class="d-flex align-items-center">
      <button mat-icon-button class="menu-button" (click)="openSidenav.emit()">
        <mat-icon class="back-arrow-icon">menu</mat-icon>
      </button>
      <button mat-icon-button class="back-button" (click)="goBack()">
        <mat-icon class="back-arrow-icon">arrow_back</mat-icon>
      </button>
      <img src="../../../../assets/images/salud/SALUD-ICON.png" alt="Salud Digital" class="img-salud-logo">
      <!-- <h1 class="header-text text-light" [class.licesing-discipline]="hasRoute('licesing-discipline')">{{hasRoute('licesing-discipline') ? 'FORMULARIO UNICO DE LA JUNTA DE LICENCIAMIENTO Y DISCIPLINA MÉDICA (JLDM)' : 'Salud Digital'}}</h1> -->
    </div>

    <div class="d-flex align-items-center">
      <a href="/">
        <img src="assets/images/salud/Logo_SALUD_rev.png" alt="Salud Digital" class="img-salud">
      </a>
    </div>
  </div>

  <!-- Vista para móvil - se oculta en medical-certificates en desktop -->
  <!-- <div [class]="hasRoute('medical-certificates') ? 'p-0 d-block d-md-none mobile-header w-100' : 'p-0 d-block d-md-none mobile-header'">
    <div class="d-flex align-items-end justify-content-between w-100 h-100 pb-2 px-1">
      <button mat-icon-button class="back-button ml-1" (click)="goBack()">
        <mat-icon class="back-arrow-icon">arrow_back</mat-icon>
      </button>
      
      <div class="col-6 text-center">
        <img src="assets/images/Salud.png" alt="Salud Digital" class="mobile-logo">
      </div>
      
      <div class="d-flex align-items-center">
        <img *ngIf="!hasRoute('medical-certificates') || hasRoute('medical-certificates/doctor')" src="assets/images/salud/doctor/profile_change.svg" alt="Cambiar perfil" class="profile-change-icon" (click)="openProfileSelectionModal()">
        
        <button [hidden]="inSideNav" mat-icon-button (click)="openSidenav.emit()" class="menu-button mr-1">
          <mat-icon class="back-arrow-icon">menu</mat-icon>
        </button>
      </div>
    </div>
  </div> -->

</header>

<!-- Banner solo para medical-certificates en desktop (debajo del header) -->
<!-- <div [class]="(router.url === '/medical-certificates' || router.url === '/medical-certificates/doctor') ? 'w-100 p-0 m-0 d-none d-md-block' : 'd-none'">
  <img src="assets/images/salud/banner/banner-xl.png" alt="Banner Salud Digital" class="w-100" style="display: block;">
</div> -->

<!-- Ocultar el menú en la ruta medical-certificates -->
<ng-container
  *ngIf="this.authService.isLoggedIn() && !hasRoute('login') && !hasRoute('login-admin') && !hasRoute('forgotPassword') && !hasRoute('licesing-discipline')">

  <div [ngClass]="(hasRoute('category-detail') || hasRoute('transaction-type') || router.url == '/') && !inSideNav  ? 'col-12 submenu-container' : 
                                  'col-12 p-0'" class="px-5 header-container">
    <div [class]="inSideNav ? 'col-12 p-0' : ''">

      <nav [class]="inSideNav ? '' : 'my-2 my-md-0 mr-md-3 nav d-none d-md-inline-block w-100'">

        <a class="nav-link p-2 d-md-none" (click)="openNotifications()">
          <mat-icon matBadge="{{notificationService.messageCount}}" *ngIf="notificationService.messageCount>0"
            matBadgeColor="warn">
            notification_important
          </mat-icon>
          <mat-icon *ngIf="notificationService.messageCount < 1" matBadgeColor="warn">
            notification_important
          </mat-icon>
          <span class="cdk-visually-hidden">
            Tienes {{notificationService.messageCount}} notificaciones por leer
          </span>
        </a>

        <div class="w-100 d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <!-- INICIO -->
            <a *ngIf="!this.authService.hasRole('tecnico interno')" mat-button class="nav-link p-3"
              [routerLinkActive]="'active'" [routerLink]="''" [routerLinkActiveOptions]="{exact:true}">
              {{ 'menu.home' | translate }}
            </a>

            <!-- TRAMITES DISPONIBLES -->
            <a *ngIf="!this.authService.hasRole('tecnico interno')" mat-button class="nav-link p-3"
              [routerLinkActive]="'active'" [routerLink]="'/available-transactions'"
              [routerLinkActiveOptions]="{exact:true}" hidden>
              {{ 'menu.availableTransactions' | translate }}
            </a>

            <!-- MIS SOLICITUDES -->
            <a mat-button class="nav-link p-3" [routerLinkActive]="'active'" [routerLink]="'/my-request'"
              *ngIf="!this.authService.hasRole('tecnico interno')">
              {{ 'menu.myTransactions' | translate }}
            </a>

            <!-- SOLICITUDES (TECNICO) -->
            <a mat-button class="nav-link p-3" [routerLinkActive]="'active'" [routerLink]="'/transactions-admin'"
              [routerLinkActiveOptions]="{exact:true}" *ngIf="this.authService.hasRole('tecnico interno')">
              {{ 'menu.transactions' | translate }}
            </a>

            <button id="btn-notifications" (click)="openNotifications()"
              [class]="inSideNav ? 'd-none' : 'mt-3 mat-button nav d-none d-md-inline-block'">
              <mat-icon class="icon-white" matBadge="{{notificationService.messageCount}}"
                *ngIf="notificationService.messageCount > 0" matBadgeColor="warn">
                notification_important
              </mat-icon>
              <mat-icon class="icon-white" *ngIf="notificationService.messageCount < 1" matBadgeColor="warn">
                notification_important
              </mat-icon>
              <span class="cdk-visually-hidden">
                Tienes {{notificationService.messageCount}} notificaciones por leer
              </span>
            </button>



            <button [class]="inSideNav ? 'd-none' : 'mat-button h-100 nav d-none d-md-inline-block'"
              [disableRipple]="true" mat-button [matMenuTriggerFor]="menu">
              <mat-icon class="icon-white">person</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/account'"
                routerLinkActiveOptions="{exact:
            true}">
                <mat-icon>person</mat-icon>{{ 'menu.myAccount' | translate }}
              </button>

              <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
                routerLinkActive="active" [routerLink]="'/account/profiles'" routerLinkActiveOptions="{exact:
          true}">
                <mat-icon>people</mat-icon>{{ 'menu.myProfiles' | translate }}
              </button>

              <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
                routerLinkActive="active" [routerLink]="'/account/receipts'" routerLinkActiveOptions="{exact:
          true}">
                <mat-icon>receipt</mat-icon>{{ 'menu.myReciepts' | translate }}
              </button>
              <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
                routerLinkActive="active" [routerLink]="'/credit-purchase'" routerLinkActiveOptions="{exact:true}">
                <mat-icon>credit_card</mat-icon>{{ 'menu.credit' | translate }}
              </button>
              <!-- <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
                routerLinkActive="active" [routerLink]="'/account/payments'" routerLinkActiveOptions="{exact:
          true}">
                <mat-icon>monetization_on</mat-icon>{{ 'payment.paymentPlans' | translate }}
              </button> -->

              <!-- <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
                routerLinkActive="active" [routerLink]="'/fine-list'" routerLinkActiveOptions="{exact:true}">
                <mat-icon>account_balance</mat-icon>{{ 'menu.fines' | translate }}
              </button> -->

              <!-- <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="['/stamps/list']"
                routerLinkActiveOptions="{exact:true}">
                <mat-icon>medical_services</mat-icon>Sellos
              </button> -->

              <mat-divider></mat-divider>

              <button mat-menu-item class="pr-4" (click)="tryLogout()">
                <mat-icon class="icon-flipped">login</mat-icon>
                {{ 'menu.leave' | translate }}
              </button>
            </mat-menu>

            <button mat-button [class]="inSideNav ? 'd-none' : 'mat-button h-100 nav d-none d-md-inline-block'"
              [disableRipple]="true" [matMenuTriggerFor]="menu2">
              <mat-icon class="language icon-white">language</mat-icon>
            </button>

            <mat-menu #menu2="matMenu" class="pr-3 pl-3">
              <button mat-menu-item style="outline: none !important;" (click)="setLanguage('es')">Español
              </button>
              <button mat-menu-item style="outline: none !important;" (click)="setLanguage('en')">English
              </button>
            </mat-menu>

          </div>
          <div class="change-profile-section" (click)="openProfileSelectionModal()"
            *ngIf="!this.authService.hasRole('tecnico interno')">
            <img src="assets/images/salud/icons/face_shake.svg" alt="Cambiar perfil" class="profile-change-icon">
            <span class="text-light fw-bold">
              Cambiar perfil
            </span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </div>
        </div>

        <a *ngIf="!this.authService.hasRole('tecnico interno')" mat-button class="nav-link p-3"
          [routerLinkActive]="'active'" [routerLink]="'/available-transactions'"
          [routerLinkActiveOptions]="{exact:true}" hidden>
          {{ 'menu.availableTransactions' | translate }}
        </a>

        <!-- <a mat-button class="nav-link p-2 " [routerLinkActive]="'active'" [routerLink]="'/medical-certificates'"
          [routerLinkActiveOptions]="{exact:true}" *ngIf="!this.authService.hasRole('tecnico interno')">
          Mis sellos
        </a> -->

        <!-- <a mat-button class="nav-link p-3" [routerLinkActive]="'active'" [routerLink]="'/transactions-admin'"
          [routerLinkActiveOptions]="{exact:true}" *ngIf="this.authService.hasRole('tecnico interno')">
          {{ 'menu.transactions' | translate }}
        </a> -->

        <!-- Motor de Búsqueda with dropdown submenu -->
        <button *ngIf="inSideNav && !hasRoute('login') && !hasRoute('login-admin') && !hasRoute('forgotPassword')" 
          mat-button class="nav-link p-2" 
          [matMenuTriggerFor]="searchMenu">
          Motor de Búsqueda
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #searchMenu="matMenu">
          <button mat-menu-item 
            [routerLinkActive]="'active'"
            [routerLink]="'/medical-professional-search'" 
            [routerLinkActiveOptions]="{exact:true}">
            Profesional de la Salud
          </button>
        </mat-menu>

        <a *ngIf="inSideNav" mat-button class="nav-link p-2 " [routerLinkActive]="'active'" [routerLink]="'/account'"
          [routerLinkActiveOptions]="{exact:true}">
          {{ 'menu.myAccount' | translate }}
        </a>

        <a *ngIf="inSideNav && !this.authService.hasRole('tecnico interno')" mat-button class="nav-link p-2 "
          [routerLinkActive]="'active'" [routerLink]="'/account/profiles'" [routerLinkActiveOptions]="{exact:true}">
          {{ 'menu.myProfiles' | translate }}
        </a>

        <a *ngIf="inSideNav && !this.authService.hasRole('tecnico interno')" mat-button class="nav-link p-2 "
          [routerLinkActive]="'active'" [routerLink]="'/account/receipts'" [routerLinkActiveOptions]="{exact:true}">
          {{ 'menu.myReciepts' | translate }}
        </a>


        <a [disabled]="inSideNav" [disableRipple]="true" mat-button class="nav-link p-2 "
          [matMenuTriggerFor]="reportsMenu" hidden>
          {{ 'menu.reports' | translate }}
        </a>
        <mat-menu #reportsMenu="matMenu">

          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/reports'"
            routerLinkActiveOptions="{exact:true}">
            {{'reports.dashboard' | translate}}
          </button>

          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/reports/certification/count'"
            routerLinkActiveOptions="{exact:true}">
            {{ 'reports.certification-type-count' | translate }}
          </button>

          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/reports/status'"
            routerLinkActiveOptions="{exact:true}">
            {{ 'reports.status' | translate }}
          </button>

          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/reports/revenue'"
            routerLinkActiveOptions="{exact:true}">
            {{ 'reports.revenue' | translate }}
          </button>

          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/reports/transaction/date'"
            routerLinkActiveOptions="{exact:true}">
            {{ 'reports.transaction-date' | translate }}
          </button>

          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/reports/solicited/copies'"
            routerLinkActiveOptions="{exact:true}">
            {{ 'reports.solicited-copies' | translate }}
          </button>
        </mat-menu>


        <a *ngIf="inSideNav" mat-button class="nav-link p-2 " (click)="tryLogout()">
          <mat-icon class="icon-flipped mr-2">login</mat-icon>{{ 'menu.leave' | translate }}
        </a>


      </nav>


      <!-- <button id="btn-notifications" (click)="openNotifications()"
        [class]="inSideNav ? 'd-none' : 'mt-3 mat-button nav d-none d-md-inline-block'">
        <mat-icon matBadge="{{notificationService.messageCount}}" *ngIf="notificationService.messageCount > 0"
          matBadgeColor="warn">
          notification_important
        </mat-icon>
        <mat-icon *ngIf="notificationService.messageCount < 1" matBadgeColor="warn">
          notification_important
        </mat-icon>
        <span class="cdk-visually-hidden">
          Tienes {{notificationService.messageCount}} notificaciones por leer
        </span>
      </button>

      <div class="d-inline">
        <button [class]="inSideNav ? 'd-none' : 'mat-button h-100 nav d-none d-md-inline-block'" [disableRipple]="true"
          mat-button *ngIf="!this.authService.hasRole('tecnico interno')" [routerLink]="'/shopping-cart'">
          <mat-icon [matBadge]="this.shoppingCartService.qtyProducts" matBadgeColor="warn">shopping_cart</mat-icon>
        </button>

        <button [class]="inSideNav ? 'd-none' : 'mat-button h-100 nav d-none d-md-inline-block'" [disableRipple]="true"
          mat-button [matMenuTriggerFor]="menu">
          <mat-icon>person</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="'/account'"
            routerLinkActiveOptions="{exact:
          true}">
            <mat-icon>person</mat-icon>{{ 'menu.myAccount' | translate }}
          </button>

          <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
            routerLinkActive="active" [routerLink]="'/account/profiles'" routerLinkActiveOptions="{exact:
        true}">
            <mat-icon>people</mat-icon>{{ 'menu.myProfiles' | translate }}
          </button>

          <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
            routerLinkActive="active" [routerLink]="'/account/receipts'" routerLinkActiveOptions="{exact:
        true}">
            <mat-icon>receipt</mat-icon>{{ 'menu.myReciepts' | translate }}
          </button>
          <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
            routerLinkActive="active" [routerLink]="'/credit-purchase'" routerLinkActiveOptions="{exact:true}">
            <mat-icon>credit_card</mat-icon>{{ 'menu.credit' | translate }}
          </button>
          <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
            routerLinkActive="active" [routerLink]="'/account/payments'" routerLinkActiveOptions="{exact:
        true}">
            <mat-icon>monetization_on</mat-icon>{{ 'payment.paymentPlans' | translate }}
          </button>

          <button *ngIf="!this.authService.hasRole('tecnico interno')" mat-menu-item class="pr-4"
            routerLinkActive="active" [routerLink]="'/fine-list'" routerLinkActiveOptions="{exact:true}">
            <mat-icon>account_balance</mat-icon>{{ 'menu.fines' | translate }}
          </button>

          <button mat-menu-item class="pr-4" routerLinkActive="active" [routerLink]="['/stamps/list']"
            routerLinkActiveOptions="{exact:true}">
            <mat-icon>medical_services</mat-icon>Sellos
          </button>

          <mat-divider></mat-divider>

          <button mat-menu-item class="pr-4" (click)="tryLogout()">
            <mat-icon class="icon-flipped">login</mat-icon>
            {{ 'menu.leave' | translate }}
          </button>
        </mat-menu>

        <button mat-button [class]="inSideNav ? 'd-none' : 'mat-button h-100 nav d-none d-md-inline-block'"
          [disableRipple]="true" [matMenuTriggerFor]="menu2">
          <mat-icon class="language">language</mat-icon>
        </button>

        <mat-menu #menu2="matMenu" class="pr-3 pl-3">
          <button mat-menu-item style="outline: none !important;" (click)="setLanguage('es')">Español
          </button>
          <button mat-menu-item style="outline: none !important;" (click)="setLanguage('en')">English
          </button>
        </mat-menu>

      </div> -->

      <prgov-notifications></prgov-notifications>

    </div>
  </div>
</ng-container>

<ng-container *ngIf="!authService.isLoggedIn() && !hasRoute('licesing-discipline')">
  <div [ngClass]="(hasRoute('category-detail') || hasRoute('transaction-type') || router.url == '/') && !inSideNav  ? 'col-12 d-flex justify-content-center submenu-container' : 
  'col-12 d-flex justify-content-center'">
    <div [class]="inSideNav ? 'col-9 d-flex justify-content-center' : 'd-flex justify-content-end submenu-header'">

      <nav [class]="inSideNav ? 'nav' : 'nav d-none d-md-inline-block'">

        <ng-container *ngIf="this.toggleHomeMessage == true">

        </ng-container>
        <ng-container *ngIf="!hasRoute('login') && !hasRoute('login-admin') && !hasRoute('forgotPassword') ">

          <div class="d-flex flex-md-row flex-column">
            <a mat-button 
              *ngIf="(this.toggleHomeMessage == false && !hasRoute('login') && router.url === '/') || 
            (this.toggleHomeMessage == false && hasRoute('category-detail'))"
              [ngClass]="{'nav-link p-2': true}" class="login-custom-btn" [routerLinkActive]="'active'"
              [routerLink]="'/login'" [routerLinkActiveOptions]="{exact:true}">
              <span class="login-custom-btn-text">
                {{ 'toolBar.login' | translate | uppercase }}
              </span>
            </a>
            
            <button mat-button 
              *ngIf="(this.toggleHomeMessage == false && !hasRoute('login') && router.url === '/') || 
            (this.toggleHomeMessage == false && hasRoute('category-detail'))"
              [ngClass]="{'nav-link p-2': true}" 
              class="login-custom-btn ms-md-2" 
              [matMenuTriggerFor]="searchMenuMain">
              <span class="login-custom-btn-text">
                MOTOR DE BÚSQUEDA
              </span>
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>

            <mat-menu #searchMenuMain="matMenu">
              <button mat-menu-item 
                [routerLinkActive]="'active'"
                [routerLink]="['/medical-professional-search']" 
                [routerLinkActiveOptions]="{exact:true}">
                PROFESIONAL DE LA SALUD
              </button>
            </mat-menu>
          </div>
          
        </ng-container>
      </nav>
    </div>
  </div>
</ng-container>